import { HStack, Icon, IconButton } from "@chakra-ui/react";
import { KeenSliderInstance } from "keen-slider/react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

interface Props {
  slider: KeenSliderInstance;
  currentSlide: number;
}

const ImageSliderNavigation = ({ slider, currentSlide }: Props) => {
  const slidesCount = slider.track.details.slidesLength;

  return (
    <HStack
      position="absolute"
      top="50%"
      left={2}
      right={2}
      justify="space-between"
      zIndex={2}
      transform={'translateY(-50%)'}
    >
      <IconButton
        aria-label="Prev"
        onClick={() => slider?.prev()}
        variant="plain"
        disabled={currentSlide === 0}
        color={"white"}
      >
        <Icon as={MdChevronLeft} boxSize={10} />
      </IconButton>
      <IconButton
        aria-label="Next"
        onClick={() => slider?.next()}
        variant="plain"
        disabled={currentSlide === slidesCount - 1}
        color={"white"}
      >
        <Icon as={MdChevronRight} boxSize={10} />
      </IconButton>
    </HStack>
  );
};

export default ImageSliderNavigation;
